{
  "page": {
    "title": "ผู้ใช้งาน",
    "subtitle": "จัดการผู้ที่สามารถเข้าสู่ระบบ Backoffice ได้"
  },
  "error": "โหลดผู้ใช้งานไม่สำเร็จ กรุณาลองรีเฟรชหน้า",
  "column": {
    "name": "ชื่อ",
    "email": "อีเมล",
    "roles": "สิทธิ์",
    "created": "สร้างเมื่อ",
    "actions": "การดำเนินการ"
  },
  "empty": {
    "title": "ยังไม่มีผู้ใช้งาน",
    "body": "ยังไม่มีใครถูกเพิ่มเข้าสู่ Backoffice",
    "body_can_manage": "เพิ่มผู้ใช้งานคนแรกเพื่อให้สิทธิ์เข้าถึง Backoffice"
  },
  "action": {
    "new_user": "เพิ่มผู้ใช้งาน",
    "edit": "แก้ไข",
    "set_roles": "กำหนดสิทธิ์",
    "reset_password": "รีเซ็ตรหัสผ่าน",
    "delete": "ลบ",
    "cancel": "ยกเลิก",
    "save": "บันทึก"
  },
  "create": {
    "title": "เพิ่มผู้ใช้งานใหม่",
    "subtitle": "ระบบจะสร้างรหัสผ่านชั่วคราวให้ ผู้ใช้ต้องเปลี่ยนรหัสผ่านเมื่อเข้าสู่ระบบครั้งแรก",
    "email_label": "อีเมล",
    "email_placeholder": "name@example.com",
    "name_label": "ชื่อ",
    "name_placeholder": "เช่น สมชาย ประเสริฐ",
    "roles_label": "สิทธิ์",
    "err_email_required": "กรุณากรอกอีเมลให้ถูกต้อง",
    "err_name_required": "กรุณากรอกชื่อ",
    "err_roles_required": "เลือกอย่างน้อยหนึ่งสิทธิ์",
    "submit": "เพิ่มผู้ใช้งาน",
    "success_title": "เพิ่มผู้ใช้งานสำเร็จ",
    "success_description": "แชร์รหัสผ่านนี้ให้ {{name}} ผ่านช่องทางที่ปลอดภัย ระบบจะไม่แสดงอีกครั้ง",
    "close": "เสร็จสิ้น"
  },
  "edit": {
    "title": "แก้ไขผู้ใช้งาน",
    "success": "แก้ไขผู้ใช้งานสำเร็จ"
  },
  "set_roles": {
    "title": "กำหนดสิทธิ์สำหรับ {{name}}",
    "success": "อัปเดตสิทธิ์สำเร็จ"
  },
  "reset_password": {
    "title": "รีเซ็ตรหัสผ่านสำหรับ {{name}}",
    "description": "ระบบจะสร้างรหัสผ่านชั่วคราวใหม่และออกจากระบบทุกอุปกรณ์ ผู้ใช้ต้องเปลี่ยนรหัสผ่านเมื่อเข้าสู่ระบบครั้งถัดไป",
    "confirm": "รีเซ็ตรหัสผ่าน",
    "success_title": "รีเซ็ตรหัสผ่านสำเร็จ",
    "success_description": "แชร์รหัสผ่านนี้ให้ {{name}} ผ่านช่องทางที่ปลอดภัย ระบบจะไม่แสดงอีกครั้ง",
    "close": "เสร็จสิ้น"
  },
  "delete": {
    "title": "ลบ {{name}}?",
    "description": "การดำเนินการนี้จะปิดใช้งานบัญชีและออกจากระบบทุกอุปกรณ์ ไม่สามารถย้อนกลับได้จากหน้านี้",
    "success": "ลบผู้ใช้งานสำเร็จ"
  },
  "role": {
    "admin": "แอดมิน",
    "ops": "ปฏิบัติการ",
    "viewer": "ผู้ดู"
  }
}
